<section class="grid-container hero" 
[style.background-image]="'url(' + heroInfo.backgroundImage + ')'" 
[style.background-position-y]="heroInfo.backgroundPositionY"
[style.background-color]="heroInfo.backgroundColor">
    <div class="grid-content section-content placement-center">
        <div class="width-md">
            <h1 *ngIf="heroInfo.showTitle" class="heading-xl gutter">
                {{ heroInfo.title }}
            </h1>
            <p *ngIf="heroInfo.showSubtitle" class="font-thin heading-xs gutter">
                {{ heroInfo.subtitle }}
            </p>
            <div class="section-buttons">
                <a *ngIf="heroInfo.showButton1" href="{{ heroInfo.button1Link }}" target="_blank" class="btn outlined">
                    {{ heroInfo.button1Text }}
                </a>
                <a *ngIf="heroInfo.showButton2" href="{{ heroInfo.button2Link }}" class="btn outlined">
                    {{ heroInfo.button2Text }}
                </a>
            </div>
            <ng-content></ng-content>
        </div>
    </div>
</section>